/** @license See the LICENSE file. */

// This code is auto-generated, do not modify this file!
const version = '3.9.0';
export {version};
